<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-card-title> {{ resourceName ?? "N/A" }}</v-card-title>
        <v-card-text style="max-height: 400px !important; overflow-y: scroll">
          <v-row class="mb-4 mt-1">
            <div class="red--text">
              {{ subTitle }}
            </div>
          </v-row>
          <v-row v-for="formula in value" :key="formula.formulaId" class="mb-2">
            <div class="overline primary--text pr-1 text-left">
              {{ formula.name }}
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-arrow-right-bold-outline</v-icon>
              </template>
              <span>{{ $t("formula.fields.output") }}</span>
            </v-tooltip>
            <div class="overline pr-1 text-left">
              {{ formula.output }}
            </div>
            <v-spacer />
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mx-2"
                  fab
                  x-small
                  color="accent"
                  router
                  :to="`/formula/${formula.formulaId}`"
                  v-on="on"
                >
                  <v-icon dark> mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("formula.edit") }}</span>
            </v-tooltip>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">
            {{ $t("common.cancel") }}
          </v-btn>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="red darken-1" text @click="forceRemove" v-on="on">
                {{ $t("formula.byResource.forceRemove") }}
              </v-btn>
            </template>
            <span>{{ $t("formula.byResource.forceRemoveHint") }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "FormulasByResourceDialog",

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    resourceName: {
      type: String,
      default: () => "",
    },

    subTitle: {
      type: String,
      default: () => "",
    },
  },

  computed: {
    show() {
      return this.value && this.value.length > 0;
    },
  },

  methods: {
    forceRemove() {
      this.$emit("forceRemove");
    },

    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
